<div class="form form__container sale-trip sale-trip__container">
  <div class="form__header">
    <div class="form__label-title">

      <span *ngIf="!isReturn">{{ "webPos.Trip.Trip" | translate }} - </span>
      <span *ngIf="isReturn">{{ "webPos.Trip.TripRefund" | translate }} - </span>

      <span class="form__header-brn">{{ this.tripData?.reservation.reservationId }}</span>
    </div>
  </div>

  <!-- Trip Info -->
  <ng-container *ngIf="!(loading | async)">

    <!-- Trip Payer-->
    <div class="form__content sale-trip__content">
      <!-- Left-side -->
      <div class="form__content-side" [formGroup]="tripPayerForm">
        <div class="form__content-side">
          <div class="form__content-side-label">
            {{ "webPos.PayerAddress" | translate }}
          </div>
          <div class="form__content-side-form" *ngIf="tripData.reservation.customer as customer">
            <div class="form__content-side-form-row">
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.Name' | translate" [placeholder]="customer.firstName || ''"
                  formControlName="ordererName"></app-form-input>
              </div>
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.Surname' | translate" [placeholder]="customer.lastName || ''"
                  formControlName="ordererSurname"></app-form-input>
              </div>
            </div>
            <div class="form__content-side-form-row">
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.Street' | translate" [placeholder]="(customer.address.street || '' + (' ' + customer.address.streetNo || '').trimRight())"
                  formControlName="street"></app-form-input>
              </div>
              <div class="form__content-side-form-row-item">
                <app-dropdown [label]="'webPos.State' | translate" [options]="stateOptions"
                  [placeholder]="customer.address.countryISO3Code || ''" formControlName="state"></app-dropdown>
              </div>
            </div>
            <div class="form__content-side-form-row">
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.City' | translate" [placeholder]="customer.address.city"
                  formControlName="city"></app-form-input>
              </div>
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.ZIP' | translate" [placeholder]="customer.address.zipCode"
                  formControlName="postalCode"></app-form-input>
              </div>
            </div>
            <div class="form__content-side-form-row">
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.Email' | translate" [placeholder]="customer.emailAddress"
                  formControlName="emailAddress"></app-form-input>
              </div>
              <div class="form__content-side-form-row-item">
              </div>
            </div>
            <div class="form__content-side-form-row">
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.CIN' | translate" [placeholder]="customer.CIN || ''" formControlName="CIN"></app-form-input>
              </div>
              <div class="form__content-side-form-row-item">
                <app-form-input [label]="'webPos.TIN' | translate" [placeholder]="customer.TIN || ''" formControlName="TIN"></app-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="sale-trip__footer-button-nav" *ngIf="!isReturn && isInPayment && !showVoucherButton">
          <app-card-button [buttonSize]="CardButtonSize.Small"
            [buttonBackground]="CardButtonBackground.Tertiary" [buttonIcon]="['fas', 'arrow-left']"
            (clicked)="goToInfo()">{{ 'webPos.Info' | translate }} </app-card-button>
        </div>
      </div>

      <!-- Right-side -->
      <div class="form__content-side">

        <app-payments [payments]="payments | async" [reservationId]="tripData?.reservation.reservationId" (paymentReturned)="reloadData()" (paymentsRefreshRequested)="reloadData()" [formEmail]="tripPayerForm?.get('emailAddress')?.value"></app-payments>

        <app-payments-calendar [payments]="tripData.reservation.paymentSummary.paymentConditionItems" [expanded]="(payments | async)?.length <= 3" *ngIf="!isReturn"></app-payments-calendar>

        <app-price-container [tripData]="tripDataAsync()" [isReturn]="isReturn"></app-price-container>

        <div class="sale-trip__payment-container">

          @if (showVoucherButton && paymentAvailability.has(paymentContext, 'voucher')) {
            <div class="sale-trip__payment-button">
              <app-card-button
                [buttonSize]="CardButtonSize.Small"
                [buttonIcon]="['fas', 'ticket']"
                [buttonBackground]="CardButtonBackground.Tertiary"
                [disabled]="!paymentAvailability.has(paymentContext, 'voucher') || tripPayerForm.invalid"
                (clicked)="applyVoucher()">
                {{ 'webPos.Trip.ApplyVoucher' | translate }}
              </app-card-button>
            </div>
          }
          @else {
            @if (!isInPayment) {
              <div class="sale-trip__payment-button">
                <app-card-button [buttonSize]="CardButtonSize.Small"
                  [buttonIcon]="['fas', 'arrow-right']" [buttonBackground]="CardButtonBackground.Tertiary"
                  (clicked)="goToPayment()">{{ 'webPos.Payment' | translate }}</app-card-button>
              </div>
            }

            @else {

              <div class="sale-trip__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Cash)">
                <app-card-button [buttonSize]="CardButtonSize.Small" 
                  [buttonIcon]="['fas', 'money-bill-wave']" [buttonBackground]="CardButtonBackground.Tertiary"
                  [disabled]="tripPayerForm.invalid || areReturnPaymentActionsDisabled()" (clicked)="payByCash()">{{ 'webPos.Cash' | translate }}</app-card-button>
              </div>

              <div class="sale-trip__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Card)">
                <app-card-button [buttonSize]="CardButtonSize.Small" 
                  [buttonIcon]="['fas', 'credit-card']"
                  [buttonBackground]="CardButtonBackground.Tertiary"
                  [disabled]="tripPayerForm.invalid || areReturnPaymentActionsDisabled()"
                    [warning]="!isCardPaymentEnabled()" (clicked)="payByCard()">{{ 'webPos.Card' | translate }}</app-card-button>
              </div>
              <div class="sale-trip__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Benefits)">
                <app-card-button [buttonSize]="CardButtonSize.Small" 
                  [buttonIcon]="['fas', 'money-check-dollar']" [disabled]="tripPayerForm.invalid"
                  [buttonBackground]="CardButtonBackground.Tertiary" (clicked)="showBenefitPaymentForm()">{{ 'webPos.Benefits' | translate }}</app-card-button>
              </div>
              
              <!-- DEV-14262: identify Others explicitly so only this button can use the SKODA refund exception. -->
              <div class="sale-trip__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Other)">
                <app-card-button [buttonSize]="CardButtonSize.Small" 
                  [buttonIcon]="['fas', 'money-check']" [buttonBackground]="CardButtonBackground.Tertiary"
                  [disabled]="tripPayerForm.invalid || areReturnPaymentActionsDisabled(ReturnPaymentMethod.Other)" (clicked)="payByOthers()">{{ 'webPos.Others' | translate }}</app-card-button>
              </div>

              <div class="sale-trip__payment-button" *ngIf="isReturn && canUseReturnPaymentMethod(ReturnPaymentMethod.Voucher)">
                <app-card-button [buttonSize]="CardButtonSize.Small"
                  [buttonIcon]="['fas', 'gift']" [buttonBackground]="CardButtonBackground.Tertiary"
                  [disabled]="tripPayerForm.invalid || areReturnPaymentActionsDisabled()" (clicked)="payByVoucher()">{{ 'webPos.Voucher.VoucherButton' | translate }}</app-card-button>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </ng-container>
</div>
